export const GET_CONTACTS = "GET_CONTACTS";
export const CONTACTS_QUERY="CONTACTS_QUERY"
